import {Dispatch, SetStateAction, useEffect, useState} from 'react';
import Button from '../../../../components/button';
import Modal from '../../../../components/mazraeKit/modal';
import {useTimeout} from '../../../../utilities/hooks/useTimeout/useTimeout';
import AutoOtp from '../../../auth/AutoMationSms/AutoOtp';
import OtpInput from '../../components/Lendtechpaysheet/OTPInput';

interface OtpModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  otpLength?: number;
  onSubmit: (otp: string) => void | Promise<void>;
  onClose?: () => void | Promise<void>;
  onError?: () => void;
  title?: string;
  autoSubmit?: boolean;
  isLoading?: boolean;
  timerDuration?: number;
  Error?: string;
}

const OtpModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  onClose,
  onError,
  isLoading,
  otpLength = 5,
  title = 'کد اعتبارسنجی',
  autoSubmit = true,
  timerDuration = 120,
  Error,
}: OtpModalProps) => {
  const [otp, setOtp] = useState('');

  const {formattedTime, restart, reset} = useTimeout({
    duration: timerDuration,
    onTimeout: () => {
      setIsOpen(false);
      onClose?.();
    },
  });

  const isValidOtp = otp.length === otpLength;

  // Restart timer when modal opens
  useEffect(() => {
    if (isOpen) {
      restart();
    } else {
      reset();
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!isValidOtp) return;

    try {
      await onSubmit(otp);
    } catch (error) {
      onError?.();
    } finally {
      setOtp('');
    }
  };

  useEffect(() => {
    if (autoSubmit && isValidOtp) {
      void handleSubmit();
    }
  }, [otp]);

  const handleClose = () => {
    setOtp('');
    setIsOpen(false);
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="w-[320px] flex flex-col p-6 gap-3 relative">
        <div className="absolute items-center justify-between top-3 left-3">
          <AutoOtp
            setOtp={setOtp}
            length={otpLength}
            onAutoSubmit={handleSubmit}
          />

          <button onClick={handleClose} className="absolute left-3 top-3">
            <i className="text-2xl text-gray-700 icon-nameClose-remove" />
          </button>
        </div>
        <div className="flex flex-col items-center gap-2">
          <i className="text-4xl text-gray-900 icon-chat" />
          <h5 className="text-[14px] font-normal text-gray-950">{title}</h5>
          <span className="text-[14px] font-normal text-gray-900 mt-2">
            کد اعتبارسنجی ارسال شده را وارد کنید
          </span>
        </div>
        <OtpInput
          value={otp}
          valueLength={otpLength}
          onChange={setOtp}
          timer={formattedTime}
          Error={Error}
          isLoading={isLoading}
        />

        <div className="flex items-center gap-2">
          <Button
            size="small"
            className="w-full disabled:opacity-30"
            disabled={!isValidOtp}
            isLoading={isLoading}
            baseStyles={
              'flex flex-1 items-center justify-center rounded-lg font-medium transition-colors outline-none text-md min-h-[40px]'
            }
            onClick={handleSubmit}
          >
            تایید
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OtpModal;
